<template>
    <div>
        <loading :active.sync="isLoading" :is-full-page="true" loader="dots" :height="150" :width="150" color="#ff5900"></loading>
        <CRow v-if="!isLoading">
            <CCol sm="12">
                <CCard>
                    <CCardBody>
                        <CForm inline class="float-right" v-on:submit.prevent="obtenerEventos">
                            <CSelect v-if="authData.user.perfil == 'Super Admin'" label="Campus" add-input-classes="mr5 mb5" size="sm" :options="campus" @change="obtenerAreas" :value.sync="filtros['idCampus']"/>
                            <CSelect  v-if="authData.user.perfil == 'Super Admin' || authData.user.perfil == 'Administrador'" label="Organizador" :disabled="bloquearAreasOrganizadoras" add-input-classes="mr5 mb5" size="sm" :options="areas" :value.sync="filtros['idArea']"/>
                            <CInput class="mr-2 my-0 mb5 md-w" placeholder="Buscar por fecha de inicio YYYY-mm-dd" v-model="filtros['fechaInicio']" size="sm"></CInput>  
                            <CInput class="mr-2 my-0 mb5" placeholder="Buscar" v-model="filtros['nombre']" size="sm">                    
                                <template #append>
                                    <CButton class="mr-2" color="info" size="sm" @click="obtenerEventos">
                                        <font-awesome-icon :icon="['fas', 'search']" />   
                                    </CButton>
                                </template>
                            </CInput>
                            <CButton color="primary" class="mb5" size="sm" @click="router.push('/evento/alta')">
                                <font-awesome-icon :icon="['fas', 'plus']" />    
                            </CButton>
                        </CForm>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
        <div v-if="this.authData.user.idPerfil == 1 || this.authData.user.idPerfil == 2">
            <CRow class="justify-content-center" v-if="cargando"> 
                <div class="spinner-grow text-warning m10" role="status" v-for="i in [ 1, 2, 3]"  v-bind:key="i">
                    <span class="sr-only">Cargando...</span>
                </div>
            </CRow>
            <CRow v-if="elementos.length">
                <CCol sm="6" md="4" lg="3" v-for="(elemento, index) in elementos" v-bind:key="index">
                    <CCard class="mt30">
                        <div class="card-image">
                            <img class="card-img-top" :src="(elemento.imagen != '' && elemento.imagen != null ? elemento.imagen : imgGenerico) + '?v=' + Math.random()" :alt="elemento.nombre | capitalize">
                            <div class="date-event">
                                <div class="text-date-event">{{elemento.claveCampus}}</div>
                            </div>
                        </div>
                        <div class="card-actions pr20">
                            <CButton color="light" shape="pill" class="card-icon-button" @click="showQR(elemento)">
                                <font-awesome-icon :icon="['fas', 'qrcode']" />    
                            </CButton>
                            <CButton color="light" shape="pill" class="card-icon-button" @click="showEvento(elemento)">
                                <font-awesome-icon :icon="['fas', 'info']" />    
                            </CButton>
                            <CButton color="light" shape="pill" class="card-icon-button" @click="verInscritos(elemento.id)">
                            <!--CLink color="light" shape="pill" class="btn btn-light btn-pill card-icon-button" :href="'/evento/inscritos?ev=' + encriptar(elemento.id)" target="_blank"-->
                                <font-awesome-icon :icon="['fas', 'users']" />    
                            </CButton>
                            <!--CButton color="light" shape="pill" class="card-icon-button" @click="router.push('/evento/configuracion/' + elemento.id)"-->
                            <CLink color="light" shape="pill" class="btn btn-light btn-pill card-icon-button" :href="'/evento/configuracion/' + elemento.id" target="_blank">
                                <font-awesome-icon :icon="['fas', 'cog']" />    
                            </CLink>
                        </div>
                        <CCardBody class="pt0 mt-20">
                            <h5 class="text-warning sub-text" style="font-size: 10px; text-transform:uppercase">
                                {{$moment(elemento.fechaInicio + ' ' + elemento.horaInicio).format("ddd DD [DE] MMMM YYYY [-] hh:mm A") }}
                            </h5>
                            <h6 v-if="elemento.rating >=0">
                                <span v-for="(star, index) in [1,2,3,4,5]" v-bind:key="index">
                                    <font-awesome-icon v-if="star > elemento.rating || elemento.rating == 0" class="simple-star" :icon="['fa', 'star']"></font-awesome-icon>
                                    <font-awesome-icon v-if="star <= elemento.rating && elemento.rating > 0" class="yellow-star" :icon="['fas', 'star']"></font-awesome-icon>
                                </span>
                            </h6>
                            <h5 class="card-title two-ellipsis">{{ elemento.nombre }}</h5>
                            <!--p class="card-text block-ellipsis">{{ elemento.descripcion }}</p-->
                            <CBadge shape="pill" color="primary" class="mr5" v-c-tooltip="{content: 'Cupo máximo'}">{{elemento.cupoMaximo == 0 ? 'N/A' : elemento.cupoMaximo}}</CBadge>
                            <CBadge shape="pill" color="success" class="mr5" v-c-tooltip="{content: 'Inscritos'}">{{elemento.cupoMaximo == 0 ? 'N/A': elemento.cupoMaximo - elemento.cupoDisponible}}</CBadge>
                            <CBadge shape="pill" color="warning" class="mr5" v-c-tooltip="{content: 'Cupo disponible'}">{{elemento.cupoMaximo == 0 ? 'N/A' : elemento.cupoDisponible}}</CBadge>
                        </CCardBody>
                        <CCardFooter class="centrar">
                            <CLink color="warning" shape="pill" class="btn btn-light btn-pill btn-sm mr10 mb5" size="sm" :href="'/evento/editar/' + elemento.id" target="_blank">
                                <font-awesome-icon :icon="['fas', 'edit']" class="mr5" />Editar   
                            </CLink>
                            <CButton color="danger" shape="pill" class="mr10 mb5" size="sm" @click="actualizarEstatus(elemento.id, 'Inactivo')">
                                <font-awesome-icon :icon="['fas', 'trash']" class="mr5" />Eliminar   
                            </CButton>
                            <CButton v-if="elemento.estatus == 'Activo'" color="warning" class="mb5" shape="pill" size="sm" @click="actualizarEstatus(elemento.id, 'Cancelado')">
                                <font-awesome-icon :icon="['fas', 'ban']" class="mr5" />Cancelar   
                            </CButton>
                            <CButton v-else color="success" shape="pill" size="sm" class="mb5" @click="actualizarEstatus(elemento.id, 'Activo')">
                                <font-awesome-icon :icon="['fas', 'check']" class="mr5" />Activar   
                            </CButton>
                        </CCardFooter>
                    </CCard>
                </CCol>
            </CRow>
            <CRow v-if="!elementos.length && !cargando">
                <CCol sm="12">
                    <alert-sin-resultados v-if="!elementos.length && !error"></alert-sin-resultados>    
                    <alert-error v-else-if="error"></alert-error>    
                </CCol>
            </CRow>
            <CRow>
                <CCol sm="12">
                    <pagination v-if="pagination.last_page > 1 && !cargando" :pagination="pagination" :offset="5" @paginate="obtenerEventos($event)"></pagination>
                </CCol>
            </CRow>
        </div>

        <div v-if="!isLoading && !(this.authData.user.idPerfil == 1 || this.authData.user.idPerfil == 2)">
            <CRow v-if="global.length">
                <CCol>
                    <div class="label-item">
                        <p>Eventos disponibles.</p>
                    </div>
                    <div v-if="global.length == 0" class="no-items">
                        <font-awesome-icon :icon="['fas', 'info-circle']" />
                        <p>
                           No hay coincidencia en búsuqeda
                        </p>
                    </div>
                     <CRow v-if="global.length">
                        <CCol sm="6" md="4" lg="3" v-for="(elemento, index) in global" v-bind:key="index">
                            <CCard class="mt30">
                                <div class="card-image">
                                    <img class="card-img-top" :src="(elemento.imagen != '' && elemento.imagen != null ? elemento.imagen : imgGenerico) + '?v=' + Math.random()" :alt="elemento.nombre | capitalize">
                                    <div class="date-event">
                                        <div class="text-date-event">{{elemento.claveCampus}}</div>
                                    </div>
                                    <div v-if="elemento.creator" class="owner">
                                        <font-awesome-icon :icon="['fas','lock']" />
                                        <p>{{elemento.creator}}</p>
                                    </div>
                                </div>
                                <div class="card-actions pr20 mt-20">
                                    <!-- <CButton color="light" shape="pill" class="card-icon-button" @click="showQR(elemento)">
                                        <font-awesome-icon :icon="['fas', 'qrcode']" />    
                                    </CButton>
                                    <CButton color="light" shape="pill" class="card-icon-button" @click="showEvento(elemento)">
                                        <font-awesome-icon :icon="['fas', 'info']" />    
                                    </CButton>
                                    <CButton color="light" shape="pill" class="card-icon-button" @click="verInscritos(elemento.id)">
                                    
                                        <font-awesome-icon :icon="['fas', 'users']" />    
                                    </CButton>
                                    
                                    <CLink color="light" shape="pill" class="btn btn-light btn-pill card-icon-button" :href="'/evento/configuracion/' + elemento.id" target="_blank">
                                        <font-awesome-icon :icon="['fas', 'cog']" />    
                                    </CLink> -->
                                </div>
                                <CCardBody class="pt0 margin-top-10">
                                    <h5 class="text-warning sub-text" style="font-size: 10px; text-transform:uppercase">
                                        {{$moment(elemento.fechaInicio + ' ' + elemento.horaInicio).format("ddd DD [DE] MMMM YYYY [-] hh:mm A") }}
                                    </h5>
                                    <h5 class="card-title two-ellipsis">{{ elemento.nombre }}</h5>
                                    <!--p class="card-text block-ellipsis">{{ elemento.descripcion }}</p-->
                                    <CBadge shape="pill" color="primary" class="mr5" v-c-tooltip="{content: 'Cupo máximo'}">{{elemento.cupoMaximo == 0 ? 'N/A' : elemento.cupoMaximo}}</CBadge>
                                    <CBadge shape="pill" color="success" class="mr5" v-c-tooltip="{content: 'Inscritos'}">{{elemento.cupoMaximo == 0 ? 'N/A': elemento.cupoMaximo - elemento.cupoDisponible}}</CBadge>
                                    <CBadge shape="pill" color="warning" class="mr5" v-c-tooltip="{content: 'Cupo disponible'}">{{elemento.cupoMaximo == 0 ? 'N/A' : elemento.cupoDisponible}}</CBadge>
                                </CCardBody>
                                <CCardFooter class="centrar">
                                    <CLink color="warning" shape="pill" class="btn btn-light btn-pill btn-sm mr10 mb5" size="sm" :href="'/evento/editar/' + elemento.id" target="_blank">
                                        <font-awesome-icon :icon="['fas', 'edit']" class="mr5" />Editar   
                                    </CLink>
                                    <!-- <CButton color="danger" shape="pill" class="mr10 mb5" size="sm" @click="actualizarEstatus(elemento.id, 'Inactivo')">
                                        <font-awesome-icon :icon="['fas', 'trash']" class="mr5" />Eliminar   
                                    </CButton>
                                    <CButton v-if="elemento.estatus == 'Activo'" color="warning" class="mb5" shape="pill" size="sm" @click="actualizarEstatus(elemento.id, 'Cancelado')">
                                        <font-awesome-icon :icon="['fas', 'ban']" class="mr5" />Cancelar   
                                    </CButton>
                                    <CButton v-else color="success" shape="pill" size="sm" class="mb5" @click="actualizarEstatus(elemento.id, 'Activo')">
                                        <font-awesome-icon :icon="['fas', 'check']" class="mr5" />Activar   
                                    </CButton> -->
                                </CCardFooter>
                            </CCard>
                        </CCol>
                    </CRow>
                </CCol>
            </CRow>
            <CRow>
                <CCol>
                    <div class="label-item">
                        <p>Eventos creados por tí.</p>
                    </div>
                    <div v-if="created.length == 0" class="no-items">
                        <font-awesome-icon :icon="['fas', 'info-circle']" />
                        <p>
                            No tienes registro de elementos creados por ti. Edita un evento para reclamar su propiedad.
                        </p>
                    </div>
                     <CRow v-if="created.length">
                        <CCol sm="6" md="4" lg="3" v-for="(elemento, index) in created" v-bind:key="index">
                            <CCard class="mt30">
                                <div class="card-image">
                                    <img class="card-img-top" :src="(elemento.imagen != '' && elemento.imagen != null ? elemento.imagen : imgGenerico) + '?v=' + Math.random()" :alt="elemento.nombre | capitalize">
                                    <div class="date-event">
                                        <div class="text-date-event">{{elemento.claveCampus}}</div>
                                    </div>
                                    <div v-if="elemento.creator" class="owner">
                                        <font-awesome-icon :icon="['fas','lock']" />
                                        <p>{{elemento.creator}}</p>
                                    </div>
                                </div>
                                <div class="card-actions pr20">
                                    <CButton color="light" shape="pill" class="card-icon-button" @click="showQR(elemento)">
                                        <font-awesome-icon :icon="['fas', 'qrcode']" />    
                                    </CButton>
                                    <CButton color="light" shape="pill" class="card-icon-button" @click="showEvento(elemento)">
                                        <font-awesome-icon :icon="['fas', 'info']" />    
                                    </CButton>
                                    <CButton color="light" shape="pill" class="card-icon-button" @click="verInscritos(elemento.id)">
                                    <!--CLink color="light" shape="pill" class="btn btn-light btn-pill card-icon-button" :href="'/evento/inscritos?ev=' + encriptar(elemento.id)" target="_blank"-->
                                        <font-awesome-icon :icon="['fas', 'users']" />    
                                    </CButton>
                                    <!--CButton color="light" shape="pill" class="card-icon-button" @click="router.push('/evento/configuracion/' + elemento.id)"-->
                                    <CLink color="light" shape="pill" class="btn btn-light btn-pill card-icon-button" :href="'/evento/configuracion/' + elemento.id" target="_blank">
                                        <font-awesome-icon :icon="['fas', 'cog']" />    
                                    </CLink>
                                </div>
                                <CCardBody class="pt0 mt-20">
                                    <h5 class="text-warning sub-text" style="font-size: 10px; text-transform:uppercase">
                                        {{$moment(elemento.fechaInicio + ' ' + elemento.horaInicio).format("ddd DD [DE] MMMM YYYY [-] hh:mm A") }}
                                    </h5>
                                    <h5 class="card-title two-ellipsis">{{ elemento.nombre }}</h5>
                                    <!--p class="card-text block-ellipsis">{{ elemento.descripcion }}</p-->
                                    <CBadge shape="pill" color="primary" class="mr5" v-c-tooltip="{content: 'Cupo máximo'}">{{elemento.cupoMaximo == 0 ? 'N/A' : elemento.cupoMaximo}}</CBadge>
                                    <CBadge shape="pill" color="success" class="mr5" v-c-tooltip="{content: 'Inscritos'}">{{elemento.cupoMaximo == 0 ? 'N/A': elemento.cupoMaximo - elemento.cupoDisponible}}</CBadge>
                                    <CBadge shape="pill" color="warning" class="mr5" v-c-tooltip="{content: 'Cupo disponible'}">{{elemento.cupoMaximo == 0 ? 'N/A' : elemento.cupoDisponible}}</CBadge>
                                </CCardBody>
                                <CCardFooter class="centrar">
                                    <CLink color="warning" shape="pill" class="btn btn-light btn-pill btn-sm mr10 mb5" size="sm" :href="'/evento/editar/' + elemento.id" target="_blank">
                                        <font-awesome-icon :icon="['fas', 'edit']" class="mr5" />Editar   
                                    </CLink>
                                    <CButton color="danger" shape="pill" class="mr10 mb5" size="sm" @click="actualizarEstatus(elemento.id, 'Inactivo')">
                                        <font-awesome-icon :icon="['fas', 'trash']" class="mr5" />Eliminar   
                                    </CButton>
                                    <CButton v-if="elemento.estatus == 'Activo'" color="warning" class="mb5" shape="pill" size="sm" @click="actualizarEstatus(elemento.id, 'Cancelado')">
                                        <font-awesome-icon :icon="['fas', 'ban']" class="mr5" />Cancelar   
                                    </CButton>
                                    <CButton v-else color="success" shape="pill" size="sm" class="mb5" @click="actualizarEstatus(elemento.id, 'Activo')">
                                        <font-awesome-icon :icon="['fas', 'check']" class="mr5" />Activar   
                                    </CButton>
                                </CCardFooter>
                            </CCard>
                        </CCol>
                    </CRow>
                </CCol>
            </CRow>
            <CRow>
                <CCol>
                    <div class="label-item">
                        <p>Eventos compartidos contigo.</p>
                    </div>
                    <div v-if="shared.length == 0" class="no-items">
                        <font-awesome-icon :icon="['fas', 'info-circle']" />
                        <p>
                            No tienes registro de eventos compartidos.
                        </p>
                    </div>
                    <CRow v-if="shared.length">
                        <CCol sm="6" md="4" lg="3" v-for="(elemento, index) in shared" v-bind:key="index">
                            <CCard class="mt30">
                                <div class="card-image">
                                    <img class="card-img-top" :src="(elemento.imagen != '' && elemento.imagen != null ? elemento.imagen : imgGenerico) + '?v=' + Math.random()" :alt="elemento.nombre | capitalize">
                                    <div class="date-event">
                                        <div class="text-date-event">{{elemento.claveCampus}}</div>
                                    </div>
                                    <div v-if="elemento.creator" class="owner">
                                         <font-awesome-icon :icon="['fas','lock']" />
                                        <p>{{elemento.creator}}</p>
                                    </div>
                                </div>
                                <div class="card-actions pr20">
                                    <CButton color="light" shape="pill" class="card-icon-button" @click="showQR(elemento)">
                                        <font-awesome-icon :icon="['fas', 'qrcode']" />    
                                    </CButton>
                                    <CButton color="light" shape="pill" class="card-icon-button" @click="showEvento(elemento)">
                                        <font-awesome-icon :icon="['fas', 'info']" />    
                                    </CButton>
                                    <CButton color="light" shape="pill" class="card-icon-button" @click="verInscritos(elemento.id)">
                                    <!--CLink color="light" shape="pill" class="btn btn-light btn-pill card-icon-button" :href="'/evento/inscritos?ev=' + encriptar(elemento.id)" target="_blank"-->
                                        <font-awesome-icon :icon="['fas', 'users']" />    
                                    </CButton>
                                    <!--CButton color="light" shape="pill" class="card-icon-button" @click="router.push('/evento/configuracion/' + elemento.id)"-->
                                    <CLink color="light" shape="pill" class="btn btn-light btn-pill card-icon-button" :href="'/evento/configuracion/' + elemento.id" target="_blank">
                                        <font-awesome-icon :icon="['fas', 'cog']" />    
                                    </CLink>
                                </div>
                                <CCardBody class="pt0 mt-20">
                                    <h5 class="text-warning sub-text" style="font-size: 10px; text-transform:uppercase">
                                        {{$moment(elemento.fechaInicio + ' ' + elemento.horaInicio).format("ddd DD [DE] MMMM YYYY [-] hh:mm A") }}
                                    </h5>
                                    <h5 class="card-title two-ellipsis">{{ elemento.nombre }}</h5>
                                    <!--p class="card-text block-ellipsis">{{ elemento.descripcion }}</p-->
                                    <CBadge shape="pill" color="primary" class="mr5" v-c-tooltip="{content: 'Cupo máximo'}">{{elemento.cupoMaximo == 0 ? 'N/A' : elemento.cupoMaximo}}</CBadge>
                                    <CBadge shape="pill" color="success" class="mr5" v-c-tooltip="{content: 'Inscritos'}">{{elemento.cupoMaximo == 0 ? 'N/A': elemento.cupoMaximo - elemento.cupoDisponible}}</CBadge>
                                    <CBadge shape="pill" color="warning" class="mr5" v-c-tooltip="{content: 'Cupo disponible'}">{{elemento.cupoMaximo == 0 ? 'N/A' : elemento.cupoDisponible}}</CBadge>
                                </CCardBody>
                                <CCardFooter class="centrar">
                                    <CLink color="warning" shape="pill" class="btn btn-light btn-pill btn-sm mr10 mb5" size="sm" :href="'/evento/editar/' + elemento.id" target="_blank">
                                        <font-awesome-icon :icon="['fas', 'edit']" class="mr5" />Editar   
                                    </CLink>
                                    <CButton color="danger" shape="pill" class="mr10 mb5" size="sm" @click="actualizarEstatus(elemento.id, 'Inactivo')">
                                        <font-awesome-icon :icon="['fas', 'trash']" class="mr5" />Eliminar   
                                    </CButton>
                                    <CButton v-if="elemento.estatus == 'Activo'" color="warning" class="mb5" shape="pill" size="sm" @click="actualizarEstatus(elemento.id, 'Cancelado')">
                                        <font-awesome-icon :icon="['fas', 'ban']" class="mr5" />Cancelar   
                                    </CButton>
                                    <CButton v-else color="success" shape="pill" size="sm" class="mb5" @click="actualizarEstatus(elemento.id, 'Activo')">
                                        <font-awesome-icon :icon="['fas', 'check']" class="mr5" />Activar   
                                    </CButton>
                                </CCardFooter>
                            </CCard>
                        </CCol>
                    </CRow>
                </CCol>
            </CRow>
            <CRow>
                <CCol>
                    <div class="label-item">
                        <p>Eventos de tu área.</p>
                    </div>
                    <div v-if="category.length == 0" class="no-items">
                        <font-awesome-icon :icon="['fas', 'info-circle']" />
                        <p>
                            No hay datos disponibles en tu categoría.
                        </p>
                    </div>
                    <CRow v-if="category.length">
                        <CCol sm="6" md="4" lg="3" v-for="(elemento, index) in category" v-bind:key="index">
                            <CCard class="mt30">
                                <div class="card-image">
                                    <img class="card-img-top" :src="(elemento.imagen != '' && elemento.imagen != null ? elemento.imagen : imgGenerico) + '?v=' + Math.random()" :alt="elemento.nombre | capitalize">
                                    <div class="date-event">
                                        <div class="text-date-event">{{elemento.claveCampus}}</div>
                                    </div>
                                    <div v-if="elemento.creator" class="owner">
                                         <font-awesome-icon :icon="['fas','lock']" />
                                        <p>{{elemento.creator}}</p>
                                    </div>
                                </div>
                                <div class="card-actions pr20">
                                    <!-- <CButton color="light" shape="pill" class="card-icon-button" @click="showQR(elemento)">
                                        <font-awesome-icon :icon="['fas', 'qrcode']" />    
                                    </CButton>
                                    <CButton color="light" shape="pill" class="card-icon-button" @click="showEvento(elemento)">
                                        <font-awesome-icon :icon="['fas', 'info']" />    
                                    </CButton>
                                    <CButton color="light" shape="pill" class="card-icon-button" @click="verInscritos(elemento.id)">
                                    
                                        <font-awesome-icon :icon="['fas', 'users']" />    
                                    </CButton>
                                   
                                    <CLink color="light" shape="pill" class="btn btn-light btn-pill card-icon-button" :href="'/evento/configuracion/' + elemento.id" target="_blank">
                                        <font-awesome-icon :icon="['fas', 'cog']" />    
                                    </CLink> -->
                                </div>
                                <CCardBody class="pt0 margin-top-10">
                                    <h5 class="text-warning sub-text" style="font-size: 10px; text-transform:uppercase">
                                        {{$moment(elemento.fechaInicio + ' ' + elemento.horaInicio).format("ddd DD [DE] MMMM YYYY [-] hh:mm A") }}
                                    </h5>
                                    <h5 class="card-title two-ellipsis">{{ elemento.nombre }}</h5>
                                    <!--p class="card-text block-ellipsis">{{ elemento.descripcion }}</p-->
                                    <CBadge shape="pill" color="primary" class="mr5" v-c-tooltip="{content: 'Cupo máximo'}">{{elemento.cupoMaximo == 0 ? 'N/A' : elemento.cupoMaximo}}</CBadge>
                                    <CBadge shape="pill" color="success" class="mr5" v-c-tooltip="{content: 'Inscritos'}">{{elemento.cupoMaximo == 0 ? 'N/A': elemento.cupoMaximo - elemento.cupoDisponible}}</CBadge>
                                    <CBadge shape="pill" color="warning" class="mr5" v-c-tooltip="{content: 'Cupo disponible'}">{{elemento.cupoMaximo == 0 ? 'N/A' : elemento.cupoDisponible}}</CBadge>
                                </CCardBody>
                                <CCardFooter class="centrar">
                                    <CLink color="warning" shape="pill" class="btn btn-light btn-pill btn-sm mr10 mb5" size="sm" :href="'/evento/editar/' + elemento.id" target="_blank">
                                        <font-awesome-icon :icon="['fas', 'edit']" class="mr5" />Ver   
                                    </CLink>
                                    <!-- <CButton color="danger" shape="pill" class="mr10 mb5" size="sm" @click="actualizarEstatus(elemento.id, 'Inactivo')">
                                        <font-awesome-icon :icon="['fas', 'trash']" class="mr5" />Eliminar   
                                    </CButton>
                                    <CButton v-if="elemento.estatus == 'Activo'" color="warning" class="mb5" shape="pill" size="sm" @click="actualizarEstatus(elemento.id, 'Cancelado')">
                                        <font-awesome-icon :icon="['fas', 'ban']" class="mr5" />Cancelar   
                                    </CButton>
                                    <CButton v-else color="success" shape="pill" size="sm" class="mb5" @click="actualizarEstatus(elemento.id, 'Activo')">
                                        <font-awesome-icon :icon="['fas', 'check']" class="mr5" />Activar   
                                    </CButton> -->
                                </CCardFooter>
                            </CCard>
                        </CCol>
                    </CRow>
                </CCol>
            </CRow>
            
        </div>

        <CModal
            :title="eventoSeleccionado.nombre"
            color="warning"
            :show.sync="showDialogEvent"
            @keydown.esc="showDialogEvent = false"
            >
                <CRow>
                    <CCol md="12">
                        <div>
                            <img style="width: 100%;" :src="(eventoSeleccionado.imagen != '' && eventoSeleccionado.imagen != null ? eventoSeleccionado.imagen : imgGenerico)" :alt="eventoSeleccionado.nombre | capitalize">
                            <div class="date">
                              <div class="day">{{$moment(eventoSeleccionado.fechaInicio + ' ' + eventoSeleccionado.horaInicio).format ("D")}}</div>
                                <div class="month">{{$moment(eventoSeleccionado.fechaInicio + ' ' + eventoSeleccionado.horaInicio).format ("MMM")}}</div>
                            </div>
                        </div>
                        <h6 class="mt20 text-warning">Sobre el evento</h6>
                        <p class="card-text">
                            {{eventoSeleccionado.descripcion}}
                        </p>
                        
                    </CCol>
                </CRow>
                <CRow class="mt10">
                    <CCol md="6">
                        <h6 class="text-warning">Tipo Evento</h6>
                        <p>{{eventoSeleccionado.tipoEvento}}</p>
                    </CCol>
                    <CCol>
                        <h6 class="text-warning">Categoría</h6>
                        <p>{{eventoSeleccionado.categoriaEvento}}</p>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol md="12">
                        <h6 class="text-warning">Organizador</h6>
                        <p>{{eventoSeleccionado.area}}</p>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol md="12" v-if="eventoSeleccionado.eventoVirtual">
                        <h6 class="text-warning">Evento Virtual</h6>
                        <p><a :href="eventoSeleccionado.urlVirtual" target="_blank">{{eventoSeleccionado.urlVirtual}}</a></p>
                    </CCol>
                    <CCol md="12" v-else>
                        <h6 class="text-warning">{{eventoSeleccionado.lugar + ' ' + eventoSeleccionado.sitio}}</h6>
                        <p>{{eventoSeleccionado.direccion}}</p>
                    </CCol>
                </CRow>
                <div slot="footer">
                     <CButton color="light" @click="showDialogEvent=false">
                        <font-awesome-icon :icon="['fas', 'times-circle']" /> Cerrar
                    </CButton>
                </div>    
        </CModal>
        <CModal :title="eventoSeleccionado.nombre" id="dialogQR" color="warning" :show.sync="showDialogEventQR" @keydown.esc="showDialogEventQR = false" class="centrar">
            <vue-qr :text="qr" :callback="obtenerDataQr" qid="eventoQR" :size="300"></vue-qr>
            <CountDown v-if="eventoSeleccionado.eventoVirtual == 1 && qr != ''" :seconds="tiempoVigente" />
            <alert-info v-if="eventoSeleccionado.eventoVirtual == 1" 
                msgInfo="Al ser un Evento Virtual este código QR será vigente únicamente por 2 minutos, después de ese tiempo deberá generar otro."></alert-info>        
                
            <div slot="footer">
                <CButton color="light" class="mr10" @click="showDialogEventQR=false">
                    <font-awesome-icon :icon="['fas', 'times-circle']" /> Cerrar
                </CButton>
                <CButton v-if="eventoSeleccionado.eventoVirtual == 0" color="primary" @click="downloadImage">
                    <font-awesome-icon :icon="['fas', 'download']" /> Descargar
                </CButton>
                <CButton v-else color="info" @click="generarTokenEvento(eventoSeleccionado.id, 2)">
                    <font-awesome-icon :icon="['fas', 'redo']" /> Generar QR
                </CButton>
            </div>    
        </CModal>
    </div>
</template>
<script>
import cryptoJs from '../../services/CryptoJsService';
import VueQr from 'vue-qr';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import CountDown from '@/components/CountDown.vue'

export default {
    name: 'Eventos',
    components: { cryptoJs, VueQr, Loading, CountDown },
    data () {
        return {
            router: this.$router,
            basePath: process.env.VUE_APP_API_URL,
            cargando: false,
            error: false,
            filtros: { idArea: '' },
            elementos: [],
            created: [],
            category: [],
            global: [],
            shared: [],
            pagination: { 'current_page': 1 },
            areas: [],
            tiposEvento: [],
            categoriasEvento: [],
            eventoSeleccionado: {},
            showDialogEvent: false,
            imgGenerico: '/img/evento.jpg',
            authData: this.$AuthApiService.getDataLocalStorage(),
            campusParam: '',
            campus: [],
            bloquearAreasOrganizadoras:false,
            qr: '',
            showDialogEventQR:false,
            dataImgQR: '',
            isLoading: false,
            tiempoVigente: 0
        }
    },
    methods: {
        verInscritos(id) {
            let routeData = this.router.resolve({ name: 'Inscritos al evento', query: { ev: this.encriptar(id) }});
            //this.$log(routeData);
            window.open(routeData.href, '_blank');
        },
        showQR(eventoObj) {
            this.eventoSeleccionado = eventoObj;
            this.showDialogEventQR = true;
            let minutos = 2;
            if (eventoObj.eventoVirtual == 0) {
                const fechaFin =  this.$moment(eventoObj.fechaFin + ' ' + eventoObj.horaFin, "YYYY-MM-DD HH:mm:ss");
                const fechaInicio =  this.$moment(eventoObj.fechaInicio + ' ' + eventoObj.horaInicio, "YYYY-MM-DD HH:mm:ss");
                minutos = fechaFin.diff(fechaInicio, 'm') + 90; // Se suma hora y media como colchon para mantener vigente el codigo más tiempo
                this.isLoading = true;
                this.$AuthApiService.getAccessToken().then(r => 
                    this.$axios.get(this.basePath + 'api/eventoqr-por-id/' + eventoObj.id, {
                        headers: { 'Authorization': r.token_type + ' ' + r.access_token }
                    })
                    .then(response => {
                        if (response.data.data == null) {
                            this.generarTokenEvento(eventoObj.id, minutos);
                        } else {
                            this.qr = response.data.data.codigo;
                            this.isLoading = false;
                        }
                    })
                    .catch(error => {
                        console.log(error.response);
                        this.isLoading = false;  
                    })
                );
            } else {
                this.generarTokenEvento(eventoObj.id, minutos);
            }
        },
        generarTokenEvento(idEvento, minutos) {
            this.qr = '';
            this.isLoading = true;
            this.$AuthApiService.getAccessToken().then(r => 
                this.$axios.post(this.basePath + 'api/obtener/codigo-evento', { "idEvento": idEvento, "minutosExpiracion": minutos}, {
                    headers: { 'Authorization': r.token_type + ' ' + r.access_token }
                })
                .then(response => {
                    this.tiempoVigente = (minutos * 60) + 1; //un segundos más por el tiempo de renderizado
                    this.qr = response.data.data.codigo;
                    this.isLoading = false; 
                })
                .catch(error => {
                    this.error = true;
                    this.isLoading = false; 
                })
            );
        },
        obtenerDataQr(dataImgQR, id) {
            this.dataImgQR = dataImgQR;
        },
        async downloadImage() {
            const image = await fetch(this.dataImgQR)
            const imageBlog = await image.blob()
            const imageURL = URL.createObjectURL(imageBlog)

            const link = document.createElement('a')
            link.href = imageURL
            link.download = 'QR_Evento' + this.eventoSeleccionado.id + '.png';
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        },
        queryString(obj) {
            var str = [];
            for (var p in obj) {
                if (obj.hasOwnProperty(p) && obj[p] != '' && obj[p] != null) {
                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                }
            }
            return str.join("&");
        },
        obtenerCampus() {
            this.campus.push({ value: '', label: '-Todos-'});
            this.$AuthApiService.getAccessToken().then(r => 
                this.$axios.get(this.basePath + 'api/campus?limit=0&activo=1', {
                    headers: { 'Authorization': r.token_type + ' ' + r.access_token }
                })
                .then(response => {
                    const listado = response.data.data;
                    for (const key in listado) {
                        if (listado[key].clave != 'TODAS') {
                            this.campus.push({ value: listado[key].id, label: listado[key].nombre });
                        }
                    }
                    this.filtros.idCampus = '';
                })
                .catch(error => {
                    console.log(error.response);
                })
            );
        },
        obtenerAreas() {
            this.areas = [];
            this.areas.push({ value: '', label: '-Todos-'});
            if (this.filtros.idCampus > 0) {
                this.campusParam = '&idCampus=' + this.filtros.idCampus;
            } else if (this.filtros.idCampus == '' && this.authData.user.perfil == 'Super Admin') {
                this.campusParam = '';
            }
            this.$AuthApiService.getAccessToken().then(r => 
                this.$axios.get(this.basePath + 'api/areas?limit=0&activo=1' + this.campusParam, {
                    headers: { 'Authorization': r.token_type + ' ' + r.access_token }
                })
                .then(response => {
                    const listado = response.data.data;
                    for (const key in listado) {
                        this.areas.push({ value: listado[key].id, label: listado[key].nombre });
                    }
                    if (this.filtros.idCampus > 0) {
                        this.bloquearAreasOrganizadoras = false;
                    }
                    if (this.filtros.idCampus == '' && this.authData.user.perfil == 'Super Admin') {
                        this.bloquearAreasOrganizadoras = true;
                    } 
                })
                .catch(error => {
                    console.log(error.response);
                })
            );
        },
        obtenerTiposDeEvento() {
            this.$AuthApiService.getAccessToken().then(r => 
                this.$axios.get(this.basePath + 'api/tipos-de-evento?limit=0' + this.campusParam, {
                    headers: { 'Authorization': r.token_type + ' ' + r.access_token }
                })
                .then(response => {
                    this.tiposEvento = response.data.data;
                })
                .catch(error => {
                    console.log(error.response);
                })
            );
        },
        obtenerCategoriasEvento() {
            this.$AuthApiService.getAccessToken().then(r => 
                this.$axios.get(process.env.VUE_APP_API_URL + 'api/categorias-evento?limit=0' + this.campusParam, {
                    headers: { 'Authorization': r.token_type + ' ' + r.access_token }
                })
                .then(response => {
                    this.categoriasEvento = response.data.data;
                })
                .catch(error => {
                    console.log(error.response);
                })
            );
        },
        obtenerEventos(page = null) {
            this.cargando = true;
            this.elementos = [];
            // this.pagination = { 'current_page': 1 };
            //this.authData.filtros = this.filtros;
            //this.authData.current_page = this.pagination.current_page;
            //this.$AuthApiService.encryptLocalStorage(this.authData);
            
            this.error = false;
            let hasParams = false;
            let params = "";
            let paramsToFilter = {
                byPeriod: null,
                date: null,
                orderBy: null,
                area: null,
                name: null,
                campus: null,
            };
            if (Number.isNaN(Number(page)) || Number(page) == 0) {
                this.filtros['page'] = 1;
            } else {
                this.filtros['page'] = page;
            }



            const keys = Object.keys(this.filtros);
            let index = 0;
            for (const key of keys) {
                if (this.filtros[key]) {  
                    params += (index > 0 || params!="" ?'&':'')+key+'='+ this.filtros[key];
                    index++;                
                    hasParams = true;
                }
            }
            if(this.filtros["idArea"]) {
                paramsToFilter.area = this.filtros['idArea'];
            }

            if (this.filtros["idCampus"]) {
                paramsToFilter.campus = this.filtros["idCampus"];
            }

            if (this.filtros["nombre"]) {
                paramsToFilter.name = this.filtros["nombre"];
            }

            if (this.filtros['fechaInicio']) {
                paramsToFilter.date = this.filtros['fechaInicio'];
                paramsToFilter.orderBy = "asc";
                params+= '&fMayor=true';
            } else if (this.elementos.length == 0 || !hasParams) {
                params+='&orderBy=true';
            }

            if (Number.isNaN(Number(page)) || Number(page) == 0) {
                this.pagination.current_page = 1;
            }

            if (this.authData.user.claveCampus && this.authData.user.idPerfil !=1) {
                params+="&claveCampus="+this.authData.user.claveCampus;
            }
            // console.log(page, 'Objeto de evento page');
            // console.log(Number(page),'Objeto de page de evento en Number');
            // console.log(Number.isNaN(Number(page)) || Number(page) == 0, 'need set page to 1');
            // console.log(this.filtros,'Filtros variables');
            // console.log(params, 'params query string');
            // console.log(this.pagination, 'Pagination object');
            // console.log(params);

            this.$AuthApiService.getAccessToken().then(r => {
                // this.authData.user.idPerfil == 1
                if (this.authData.user.idPerfil == 1 || this.authData.user.idPerfil == 2) {
                    this.$axios.get(process.env.VUE_APP_API_URL + 'api/eventos?'  + params, {
                        headers: {
                            'Authorization': r.token_type + ' ' + r.access_token
                        }
                    })
                    .then(response => {
                        // console.log(response);
                        this.cargando = false;
                        this.elementos = response.data.data.data;
                        this.pagination = response.data.data;
                    })
                    .catch(error => {
                        this.cargando = false;
                        this.error = true;
                    });
                } else {
                    this.isLoading = true;
                    console.log(paramsToFilter);
                    this.$axios.post(process.env.VUE_APP_API_URL + "api/eventos/gestores", {
                        userId: this.authData.user.email,
                        ...paramsToFilter,
                    }, {
                        headers: { 'Authorization': r.token_type + ' ' + r.access_token }
                    }).then(response => {
                        this.isLoading = false;
                        this.shared = [];
                        this.created = [];
                        this.category = [];
                        this.global = [];
                        this.elementos = [];
                        // console.log(response);

                        if (response.data.data.shared) {
                            
                            response.data.data.shared.map((item) => {
                                this.shared.push({...item});
                            });
                        }

                        if (response.data.data.created) {
                            
                            response.data.data.created.map((item) => {
                                this.created.push({...item});
                            });
                        }

                        if (response.data.data.category) {
                            response.data.data.category.map((item) => {
                                this.category.push({...item});
                            });
                        }

                        if (response.data.data.category) {
                            response.data.data.category.map((item) => {
                                this.category.push({...item});
                            });
                        }

                        if (response.data.data.global) {
                            response.data.data.global.map((item) => {
                                this.global.push({...item});
                            });
                        }

                        if (response.data.data.all) {
                            response.data.data.all.map((item) => {
                                this.elementos.push({...item});
                            });
                        }
                        this.cargando = false;
                    })      
                }
            } 
                
                
            )
        },
        showEvento(eventoObj) {
            this.eventoSeleccionado = eventoObj;
            this.showDialogEvent = true;
        },
        alertSelector(text = null) {
            return new Promise((resolve, reject) => {
                this.$swal({
                title: `¿Estás segur@ de ${text ? text: 'cancelar'} al evento?`,
                text: "",
                icon: 'info', 
                buttons: [
                    'Regresar',
                    `Sí, ${text ? text: 'cancelar'} evento`
                ]
                }).then((result)  => {
                    resolve(result);
                });
            });
           
        },
        async actualizarEstatus(id, estatus) {
            if (estatus == "Cancelado" || estatus == "Inactivo") {
                const confirmed = await this.alertSelector(estatus == "Inactivo" ? 'Eliminar' : 'Cancelar');
                if (!confirmed)
                return;
            } 
           
            this.error = false;    
            this.$AuthApiService.getAccessToken().then(r => 
                this.$axios.put(this.basePath + 'api/evento/' + id + '/estatus/' + estatus, {}, {
                    headers: { 'Authorization': r.token_type + ' ' + r.access_token }
                })
                .then( async (response) => {

                    if (estatus == "Cancelado" || estatus == "Inactivo") {
                        const evento = this.elementos.find(x => x.id == id);
                        if (evento) {
                            this.$notificationService.cancelEventComplete({
                                eventId: id,
                                isVFI: (evento.tipoEvento == "VFI Pass" && evento.claveCampus == "UAM")
                            });

                            if (this.evento.requiereCalificacion == 1) {
                                this.$notificationService.removeAllRatingData({
                                    event: {
                                        id: id,
                                    }
                                });
                            }
                        }

                    }
                    this.obtenerEventos();
                })
                .catch(error => {
                    this.error = true;
                })
            );
        },
        encriptar(text) {
            return cryptoJs.encrypt(text.toString())
        },
    },
    mounted() {
        /*if (typeof this.authData.filtros != 'undefined') {
            this.filtros = this.authData.filtros;
        }
        if (typeof this.authData.current_page != 'undefined') {
            this.pagination.current_page = this.authData.current_page;
        }*/
        if (this.authData.user.perfil != 'Super Admin') {
            this.campusParam = '&idCampus=' + this.authData.user.idCampus;
        } else {
            this.obtenerCampus();
            this.bloquearAreasOrganizadoras = true;
        }
        this.obtenerEventos();
        //this.obtenerTiposDeEvento();
        //this.obtenerCategoriasEvento();
        this.obtenerAreas();
    },
    filters: {
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString().toLowerCase()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    }
}
</script>
